import * as React from "react";
import { Consumer } from "../libs/AuthContext";
import config from "../config";
import { parseString } from "xml2js";
import {Grid, Segment, Icon, Button, Menu, Modal, Dropdown} from "semantic-ui-react";
import { translate } from "react-i18next";
import { getOPDS, checkSavedLocations, languages, languagesFR } from "../libs/utility";
import { Link } from "@reach/router";
import Auth from "@aws-amplify/auth"

class Library extends React.Component {
  constructor(props) {
    super(props);

    this.state ={
      entries: [],
      thumbnail: true,
      confirmLogout: false,
      showMenu: false,
      opdsLink: ""
    }
  }

 async componentDidMount() {
    try {
      let libData = await getOPDS();
      this.parseLib(libData);
      await checkSavedLocations()
    } catch (e) {
      console.log(e);
    }

  }

 parseLib = (fileData) => {
    let entries = [];
    parseString(fileData, function (err, result) {
      if (result) {
        entries = result.feed.entry;
      }
      else {
        console.log(err)
      }
    });
    this.setState({ entries })
  }
 handleLogout =  async () => {
    try {
      await Auth.signOut();
      this.props.context.userHasAuthenticated(false);
      } catch (e) {
        alert(e.message);
      }
  }

 showConfirm = () => {
    this.setState({ confirmLogout: true })
  }

 handleCancel = () => {
    this.setState({ confirmLogout: false })
  }

 renderBooks() {
    return [{}].concat(this.state.entries).map(
      (entry, index) =>
        index !== 0
        ?
          <Grid.Column key={index} className="booksTumb">
            <Segment style={{boxShadow: "0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5"}}>
            <Link to={`/${entry.link[1].$.href}`}>
            <img width={170} height={240} src={"https://s3.amazonaws.com/"+config.s3Image.BUCKET+"/public/"+entry.link[0].$.href} alt=""/>
          </Link>
            <br/>
            <p >
              <strong>{entry.title[0]}</strong>
              <br/>
              {entry.author ? entry.author[0].name : ""}
            </p>
            </Segment>
          </Grid.Column>
        : null
    );
  }

 renderBooksList() {
    return [{}].concat(this.state.entries).map(
      (entry, index) =>
        index !== 0
        ?
          <Grid.Row key={index}  className="booksList">
            <Link to={`/${entry.link[1].$.href}`} style={{padding: "0em 2em"}}>
            <img width={50} height={69} src={"https://s3.amazonaws.com/"+config.s3Image.BUCKET+"/public/"+entry.link[0].$.href} alt=""/>
          </Link>
            <div>
            <p style={{fontSize: "20px", textAlign: "left", margin: "0"}}>{entry.title[0]}</p>
            <p style={{fontSize: "15px", textAlign: "left"}}>{entry.author ? entry.author[0].name : ""}</p>
          </div>
        </Grid.Row>
        : null
    );
  }


 render () {
    const { t } = this.props
    return (
      <main className="Library">
      <Segment textAlign="center" vertical>
        <Menu fixed="top" fluid borderless size="large" as="nav" className="largeMenu">
          <Menu.Header style={{textAlign: "left"}}>
            <a href="/"><img width={200} height={"auto"} src={"/logo-horizontal.png"} alt=""/></a>
          </Menu.Header>
          <Menu.Menu position="right">
            <Menu.Item>
              <a href="http://bookchain-catalogue.s3-website-us-east-1.amazonaws.com/" className="catalogueLink">{t("Catalogue")}</a>
            </Menu.Item>
            <Menu.Item>
              <a href="http://bookchain-site.s3-website-us-east-1.amazonaws.com/" className="catalogueLink">{t("About Bookchain®")}</a>
            </Menu.Item>
            <Menu.Item>
              <Modal
              style={{backgroundColor: "transparent"}}
              basic
              size="tiny"
              open={this.state.confirmLogout}
              onOpen={this.showConfirm}
              trigger={<Button className="logoutButton">
                  {t("Sign Out")}
                </Button>
                }
              >
                <Modal.Header>{t("Are you sure you want to signout?")}</Modal.Header>
                <Modal.Actions>
                  <Button onClick={this.handleLogout}>
                    {t("Sign Out")}
                  </Button>
                  <Button onClick={this.handleCancel} className="cancelButton">
                    {t("Cancel")}
                  </Button>
                </Modal.Actions>
              </Modal>
            </Menu.Item>
            <Menu.Item>
            <Dropdown
              fluid
              selection
              options={this.props.lng === "fr" ? languagesFR : languages}
              value={this.props.lng}
              onChange={(event,data) => this.props.i18n.changeLanguage(typeof data.value === "string" ? data.value : "en")}
              />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        <Menu fixed="top" fluid borderless size="large" as="nav" className="mobileMenu">
          <Menu.Header style={{textAlign: "left"}}>
            <a target="_blank" rel="noopener noreferrer" href="https://www.bookchain.ca/"><img width={120} height={"auto"} src={"/logo-horizontal.png"} alt=""/></a>
          </Menu.Header>
          <Menu.Menu position="right">
            <Menu.Item>
              <Button icon
                onClick={() => this.setState({showMenu: !this.state.showMenu})}
                className="iconButton">
                <Icon name="align justify" style={{paddingTop: "5px"}}/>
              </Button>
            </Menu.Item>
            {this.state.showMenu &&
              <Menu vertical fluid fixed="top">
                <Menu.Item >
                  <a target="_blank"  rel="noopener noreferrer" href="http://bookchain-catalogue.s3-website-us-east-1.amazonaws.com/" style={{fontSize: "1em", color: "#FFFFFF"}}>{t("Catalogue")}</a>
                </Menu.Item>
                <Menu.Item>
                  <Modal
                  style={{backgroundColor: "transparent"}}
                  basic
                  size="tiny"
                  open={this.state.confirmLogout}
                  onOpen={this.showConfirm}
                  trigger={<Button className="logoutButton">
                      {t("Sign Out")}
                    </Button>
                    }
                  >
                    <Modal.Header>{t("Are you sure you want to logout?")}</Modal.Header>
                    <Modal.Actions>
                      <Button onClick={this.handleLogout}>
                        {t("Sign Out")}
                      </Button>
                      <Button onClick={this.handleCancel}>
                        {t("Cancel")}
                      </Button>
                    </Modal.Actions>
                  </Modal>
                </Menu.Item>
                <Menu.Item>
                <Dropdown
                  fluid
                  selection
                  options={this.props.lng === "fr" ? languagesFR : languages}
                  value={this.props.lng}
                  onChange={(event,data) => this.props.i18n.changeLanguage(typeof data.value === "string" ? data.value : "en")}
                  />
                </Menu.Item>
              </Menu>
            }
          </Menu.Menu>

        </Menu>
        </Segment>

        <Segment textAlign="center" className="libSeg">
          <Button icon onClick={() => {this.setState({thumbnail: !this.state.thumbnail})}} className="libSeg">
            <Icon size="large" name={this.state.thumbnail ? "list" : "th large"} color="black"/>
          </Button>
          <h1 style={{textAlign: "center"}}>{t("My Library")}</h1>
          {this.state.thumbnail  &&
            <Grid stackable columns={4} width={11} style={{paddingLeft: "2em", paddingRight: "2em"}}>{this.renderBooks()}
            </Grid>
          }
          {!this.state.thumbnail &&
            <Grid stackable columns={2} width={3}>{this.renderBooksList()}
            </Grid>
          }

      </Segment>
    </main>
    )
  }
}

export default translate("translations")(props => (
  <Consumer>
    {value => <Library {...props} context={value} />}
  </Consumer>
));
